// extracted by mini-css-extract-plugin
export default {"header":"ProTable_header__4LmBh","headerLeft":"ProTable_headerLeft__UhrwR"};